import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ec28c1d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5ec28c1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LocationsSearchContainer: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/locations/search/Container.vue').default})
